exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table tr{cursor:pointer}.ml5{margin-left:5px}", ""]);

// exports
